import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { ICommonAttributes } from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById } from "@utils/editor";
import { DeleteIconEditor } from '@assets/icons/deleteIconEditor';
import Tooltip from '@components/Tooltip';

const CopyPasteCommandOption : React.FC<IProps> = () => {
  let { onCommandChange} = useContext(Context);

  return (    
    <S.Root>
      <Tooltip tip={"Delete"}>
        <S.ButtonContainer onClick={()=> { onCommandChange("removeElement", {}) }}>
          <DeleteIconEditor/>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default CopyPasteCommandOption;